import React from "react";
import PropTypes from "prop-types";
import CellIcon from "./CellIcon";
import CellTextEditor from "./CellTextEditor";

const CellTextWithIcon = ({ id, x, y, text, json, style }) => {
  return (
    <>
      {style?.icon ? (
        style?.iconAlign === "center" || (!style?.iconAlign && style?.icon) ? (
          <div
            style={{
              display: "grid",
              gridTemplateRows: `${style?.iconRatio ?? 50}fr ${100 - (style?.iconRatio ?? 50)}fr`,
              height: "100%",
            }}
          >
            <CellIcon
              id={style.icon}
              iconAlign={style.iconAlign}
              iconColor={style.iconColor}
              iconSize={style.iconSize}
              iconEnclosure={style.iconEnclosure}
              iconStyle={style.iconStyle}
            />

            <CellTextEditor id={id} x={x} y={y} text={text} json={json} style={style} />
          </div>
        ) : style?.iconAlign === "left" ? (
          <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", height: "100%" }}>
            <CellIcon
              id={style.icon}
              iconAlign={style.iconAlign}
              iconColor={style.iconColor}
              iconSize={style.iconSize}
              iconEnclosure={style.iconEnclosure}
              iconStyle={style.iconStyle}
            />

            <CellTextEditor id={id} x={x} y={y} text={text} json={json} style={style} />
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", height: "100%" }}>
            <CellTextEditor id={id} x={x} y={y} text={text} json={json} style={style} />

            <CellIcon
              id={style.icon}
              iconAlign={style.iconAlign}
              iconColor={style.iconColor}
              iconSize={style.iconSize}
              iconEnclosure={style.iconEnclosure}
              iconStyle={style.iconStyle}
            />
          </div>
        )
      ) : (
        <CellTextEditor id={id} x={x} y={y} text={text} json={json} style={style} />
      )}
    </>
  );
};

CellTextWithIcon.propTypes = {
  id: PropTypes.string.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  text: PropTypes.string,
  json: PropTypes.object,
  style: PropTypes.object,
};

export default CellTextWithIcon;
